import { defineMessages } from 'react-intl';

export default defineMessages({
  modalDayTimeAvailabilityTitle: {
    id: 'common.modals.dayTimeAccess.title',
    defaultMessage: 'Custom Access Hours',
  },
});
